import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnConfig } from '../models/column-config.model';
import { EMDMICONS } from '../constants/icon-pack.constant';
import { commonService } from 'src/app/services/common.service';
import { throwIfEmpty } from 'rxjs';

@Component({
  selector: 'app-grid-mwo-error',
  templateUrl: './grid-mwo-error.component.html',
  styleUrl: './grid-mwo-error.component.scss'
})
export class GridMwoErrorComponent {
  dataList: any[] = [];

  showMwoErrorPopup: boolean = false;
  popupTitle = '';

  constructor(private commonService: commonService) { }

  popupHeight = 300;

  @Input() set setGridData(data: any) {
    if (data?.length > 0) {
      this.dataList = data;

      this.popupHeight = data.length <= 5 ? 300 : 500;
      let errorList = this.dataList.filter((x: any) => x.cridList?.length > 0)
        .map((x: any) => 'MWO ' + x.mwoNumber + ' already included in ' + x.cridList);
      
      if (errorList.length > 0) {
        errorList.push('Please contact ACD requestor to merge required changes');
        this.commonService.showNotificationMessage(errorList.join("<br>"), "error", "center");
      }
    }
  }

  iconPacks = EMDMICONS;

  openMwoErrorPopup() {
    this.showMwoErrorPopup = true;
  }

  closeMwoErrorPopup() {
    this.showMwoErrorPopup = false;
  }

}
